import { render, staticRenderFns } from "./ThreadListItem.vue?vue&type=template&id=02b87d40&scoped=true&"
import script from "./ThreadListItem.vue?vue&type=script&lang=js&"
export * from "./ThreadListItem.vue?vue&type=script&lang=js&"
import style0 from "./ThreadListItem.vue?vue&type=style&index=0&id=02b87d40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b87d40",
  null
  
)

export default component.exports